module.exports = __webpack_public_path__ + "img/首页2-1-hover.742e39e6.svg";